module.exports = __webpack_public_path__ + "static/media/anime_kyo_male.6f99f347.jpg";